export const THEME_PREFERENCE_STORAGE_KEY = 'theme'
export const THEME_PREFERENCE_LEGACY_STORAGE_KEYS = ['emporion.customer.theme.preference.v1'] as const

export type ThemePreference = 'light' | 'dark' | 'system'
export type ResolvedTheme = 'light' | 'dark'

export const DEFAULT_THEME_PREFERENCE: ThemePreference = 'light'

export const motionTokens = {
  durationFastSeconds: 0.15,
  durationNormalSeconds: 0.2,
  easingStandard: [0.22, 1, 0.36, 1] as const,
  easingEmphasized: [0.16, 1, 0.3, 1] as const,
}
